<template>
    <div>
        <div class="card card-body bg-white border-light shadow-sm mb-4">
            <h2 class="h5 mb-4">Media</h2>
            <MssImage :folder="folder" v-model="image" location="media"></MssImage>
        </div>
        <div class="row">
            <h2 class="h5 mb-4">Uploaded medias</h2>
            <div class="col-12 col-md-6 col-lg-4 col-sm-12" v-for="(image,key) in imageList" :key="key">
                <div class="card card-body bg-white border-light shadow-sm mb-4">
                    <div class="d-xl-flex align-items-center">
                        <div>
                            <div class="user-avatar xl-avatar mb-3">
                                <img class="rounded img-responsive" :src="$root.URL_ROOT+'uploads/'+folder+'/'+image.link" alt="change avatar">
                            </div>
                        </div>
                        <div class="file-field w-100">
                            <div class="d-flex justify-content-xl-center ml-xl-3 w-100">
                                <div class="d-flex w-100">
                                    <span class="icon icon-md"><span class="fas fa-paperclip mr-3"></span></span>
                                    <div class="d-md-block text-left w-100">
                                        <input type="text" readonly :value="$root.URL_ROOT+'uploads/'+folder+'/'+image.link" class="form-control">
                                        <div class="btn-group mt-1">
                                            <button class="btn btn-info btn-sm">Copy Path <i class="fa fa-copy"></i></button>
                                            <button class="btn btn-danger btn-sm">Delete <i class="fa fa-times"></i></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import $ from 'jquery'
export default {
    props:[
        "page","action","id"
    ],
    data() {
        return {
            image: null,
            folder: 'media',
            imageList: []
        }
    },
    mounted(){
        this.getAllImages()
    },
    methods: {
        getAllImages(){
            //https://dms.mragank.com/admin/media/media
            $.ajax({
                "method": 'GET',
                "url": this.URL_ROOT+'admin/media/'+this.folder,
                "success": (response)=>{
                    this.imageList = response;
                    console.log(response);
                }
            })
        }
    },
}
</script>
